import { formatDayOfMonthAndMonthFullLetter } from "../../utils/date-utils.mjs";
export function computeRange(adapter, next, displayTimezone) {
  if (next.allDay) {
    return {
      start: next.startDate === '' ? adapter.now(displayTimezone) : adapter.startOfDay(adapter.date(next.startDate, displayTimezone)),
      end: next.endDate === '' ? adapter.now(displayTimezone) : adapter.endOfDay(adapter.date(next.endDate, displayTimezone)),
      surfaceType: 'day-grid'
    };
  }
  return {
    start: next.startDate === '' || next.startTime === '' ? adapter.now(displayTimezone) : adapter.date(`${next.startDate}T${next.startTime}`, displayTimezone),
    end: next.endDate === '' || next.endTime === '' ? adapter.now(displayTimezone) : adapter.date(`${next.endDate}T${next.endTime}`, displayTimezone),
    surfaceType: 'time-grid'
  };
}
export function validateRange(adapter, start, end, allDay) {
  const startDay = adapter.startOfDay(start);
  const endDay = adapter.startOfDay(end);
  // endDay <= startDay → date error
  if (adapter.isAfter(startDay, endDay)) {
    return {
      field: 'startDate'
    };
  }
  if (adapter.isEqual(startDay, endDay)) {
    if (!allDay && !adapter.isAfter(end, start)) {
      // end <= start → hour error
      return {
        field: 'startTime'
      };
    }
  }
  return null;
}
export function getRecurrenceLabel(adapter, start, recurrenceKey, localeText) {
  if (!recurrenceKey) {
    return localeText.recurrenceNoRepeat;
  }
  switch (recurrenceKey) {
    case 'DAILY':
      return localeText.recurrenceDailyPresetLabel;
    case 'WEEKLY':
      {
        const weekday = adapter.format(start.value, 'weekday');
        return localeText.recurrenceWeeklyPresetLabel(weekday);
      }
    case 'MONTHLY':
      {
        const date = adapter.getDate(start.value);
        return localeText.recurrenceMonthlyPresetLabel(date);
      }
    case 'YEARLY':
      {
        const normalDate = formatDayOfMonthAndMonthFullLetter(start.value, adapter);
        return localeText.recurrenceYearlyPresetLabel(normalDate);
      }
    case 'custom':
      return localeText.recurrenceCustomRepeat;
    default:
      return localeText.recurrenceNoRepeat;
  }
}
export function getEndsSelectionFromRRule(rrule) {
  if (!rrule) {
    return 'never';
  }
  if (rrule.until) {
    return 'until';
  }
  if (rrule.count && rrule.count > 0) {
    return 'after';
  }
  return 'never';
}
export function hasProp(obj, prop) {
  return prop in obj;
}